// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGEllipses = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#ellipses__clip0_12_2818)",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "ellipses__a",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 32,
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#ellipses__clip1_12_2818)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M4.857 14c1.263 0 2.286 1.023 2.286 2.286 0 1.262-1.023 2.285-2.286 2.285-1.262 0-2.285-1.023-2.285-2.285C2.572 15.023 3.595 14 4.857 14zM16.286 14c1.262 0 2.285 1.023 2.285 2.286 0 1.262-1.023 2.285-2.285 2.285-1.263 0-2.286-1.023-2.286-2.285C14 15.023 15.024 14 16.286 14zM27.714 14C28.977 14 30 15.023 30 16.286c0 1.262-1.023 2.285-2.286 2.285-1.262 0-2.285-1.023-2.285-2.285 0-1.263 1.023-2.286 2.285-2.286z"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#ellipses__a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0V0z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "ellipses__clip0_12_2818",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "ellipses__clip1_12_2818",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })]
  })]
}));
SVGEllipses.displayName = 'SVGEllipses';
export default SVGEllipses;